/*STDSCM01C05
 * @Date: 2022-08-10 18:17:26
 * @LastEditTime: 2022-08-16 10:08:35
 * @Description:
 */
import { net_common } from "@/api/http";

export const API_OidcAlignment = (...params) =>
net_common.post("/api/STDSCM01C05/OidcAlignment", ...params);
